<template>
  <v-card flat ripple class="v-btn v-btn--flat pa-2 d-block ma-auto text-center"
    :class="{'active': selected, 'v-btn--disabled': !item.available}"
    @click.native="$emit('toggle', item)"
  >
    <img v-if="item.image" :src="item.image" width="80" height="80">
    <v-card-text class="pa-0">
      <div v-if="item.name" class="caption">{{ item.name }}</div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    /**
     * Whether the choice is selected or not.
     */
    selected: Boolean,
    /**
     * Holds the model for the choices, including name, image, and available attributes.
     */
    item: Object
  }
}
</script>

<style lang="scss" scoped>
.v-btn {
  border-radius: 3px;
  border: 1px solid var(--v-secondary-lighten4);
  cursor: pointer;
  height: auto;
  width: 8.5rem;
}

.v-btn--disabled {
  opacity: .4;
}

.active {
  box-shadow: 0 0 5px 1px var(--v-accent-base) !important;
  color: var(--v-accent-base) !important;
}
</style>
